(function($){

    var delayHover = function (elem, callback) {
        var timeout = null;
        elem.onmouseover = function() {
            // Set timeout to be a timer which will invoke callback after 1s
            timeout = setTimeout(callback, 100);
        };
    
        elem.onmouseout = function() {
            // Clear any timers set to timeout
            clearTimeout(timeout);
        }
    };

    /**
     * Megamenu Initialization
     * 
     * @version 1.0.0
     */
    function MegaMenu(el) {
        this.el             = el;
        this.tabTitles      = el.querySelectorAll('.tabs-title a');
        this.$tabs          = $( el.querySelector('.tabs') );
        this.menuItems      = el.querySelectorAll('.tabs-content a');
        this.defaultImage   = el.querySelector('.tt-megamenu__image');
        this.initEvents();
    }

    MegaMenu.prototype.initEvents = function() {
        this.$tabs.on( 'change.zf.tabs', function(e) {
            
        })

        // add event when submenu opens
        let $nav = $('#main-nav');
        var megamenu = this;
        const handleShowDropdown = Renoun.debounce( function(e) {
            if ( megamenu && megamenu.$tabs ) {
                megamenu.$tabs.foundation('selectTab', megamenu.tabTitles[0].attributes.href.value, false );
            }
        }, 100);
        
        $nav.eq(0).on( 'show.zf.dropdownMenu', handleShowDropdown );

        this.tabTitles.forEach( tabTitle => {
            tabTitle.addEventListener( 'click', ( e ) => {
                e.preventDefault();
                const link = e.currentTarget;
                if ( link.dataset.goTo ) {
                    window.location = link.dataset.goTo;
                }
            });
            tabTitle.addEventListener( 'mouseover', ( e ) => {
                let el = e.currentTarget;

                if ( el.dataset.imageUrl ) {
                    this.updateDefaultImageUrl( el.dataset.imageUrl );
                }
            });
            delayHover( tabTitle, function() {
                this.$tabs.foundation('selectTab', tabTitle.attributes.href.value, false );
            }.bind(this))

            this.menuItems.forEach( menuItem => {
                menuItem.addEventListener('mouseover', e => {
                    let el = e.currentTarget;

                    if ( el.dataset.imageUrl ) {
                        this.updateDefaultImageUrl( el.dataset.imageUrl );
                    }
                })
            })
        });
    }

    MegaMenu.prototype.updateDefaultImageUrl = function( imageUrl ) {
        if ( ! imageUrl || this.defaultImage.src == imageUrl ) return false;

        this.defaultImage.src = imageUrl;
        return true;
    }


    $(document).ready(function(){
        const megamenus = document.querySelectorAll('.tt-megamenu');

        megamenus.forEach( megamenu => {
            new MegaMenu( megamenu );
        });

        $('#main-nav').on( 'show.zf.dropdownMenu', function(e, $menu ) {
            $('body').addClass('megamenu-open');
        });
        $('#main-nav').on( 'hide.zf.dropdownMenu', function(e, $menu ) {
            $('body').removeClass('megamenu-open');
        });

        // temporary fix because 
        // window.acf.addAction( 'render_block_preview/type=renoun/display-posts', MegaMenu ) 
        // keeps crashing the block
        if ( $('.wp-admin').length ) {
            setTimeout( MegaMenu, 2000 );
        }
    });
    
})(jQuery);